import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { Guest, Member } from '../manage-members';

export interface ManageMembersState {
  organizationmembers: Member[];
  setOrganizationMembers: (values: Member[]) => void;

  guests: Guest[];
  setGuests: (values: Guest[]) => void;

  admin: boolean;
  setAdmin: (value: boolean) => void;

  memberCount: number;
  setMemberCount: (value: number) => void;

  isOnlyAdmin: boolean;
  setIsOnlyAdmin: (value: boolean) => void;

  isOwner: boolean;
  setIsOwner: (value: boolean) => void;

  owner: string;
  setOwner: (value: string) => void;

  pendingInvitesMembers: Member[];
  setPendingInviteMembers: (values: Member[]) => void;

  pendingInvitesGuests: Member[];
  setPendingInviteGuests: (values: Member[]) => void;
}

export const useManageMembersStore = create<
  ManageMembersState,
  [['zustand/devtools', ManageMembersState]]
>(
  devtools((set) => ({
    organizationmembers: [],
    setOrganizationMembers: ([...values]) => set({ organizationmembers: values }),

    guests: [],
    setGuests: ([...values]) => set({ guests: values }),

    admin: false,
    setAdmin: (admin) => set(() => ({ admin: admin })),

    memberCount: 0,
    setMemberCount: (memberCount) => set(() => ({ memberCount: memberCount })),

    isOnlyAdmin: false,
    setIsOnlyAdmin: (isOnlyAdmin) => set(() => ({ isOnlyAdmin: isOnlyAdmin })),

    isOwner: false,
    setIsOwner: (isOwner) => set(() => ({ isOwner: isOwner })),

    owner: '',
    setOwner: (owner) => set(() => ({ owner: owner })),

    pendingInvitesMembers: [],
    setPendingInviteMembers: (pendingInvitesMembers) =>
      set(() => ({ pendingInvitesMembers: pendingInvitesMembers })),

    pendingInvitesGuests: [],
    setPendingInviteGuests: (pendingInvitesGuests) =>
      set(() => ({ pendingInvitesGuests: pendingInvitesGuests })),
  }))
);
